/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { vappContainer } from '@/application';
import { LandingPage as LandingPageWidget } from '@widgets/landing-page-widget';

import { useSMProductLandingPage } from '../machines';
import { useTheme } from '@providers/theme';
import { VApplication } from '@/application';
import { ProductLandingPageService } from '../services';

const getSrv = () => {
  return vappContainer.get<ProductLandingPageService>(
    ProductLandingPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [buttonItem, setButtonItem] = useState();
  const srv = getSrv();

  useEffect(() => {
    async function getNavItems() {
      let _navlinks = await srv?.getHeaderNavItems();
      if (_navlinks) {
        setButtonItem(_navlinks);
      }
    }
    setTimeout(() => {
      getNavItems();
    }, 500);
  }, []);

  const {
    productLandingPageMachine,
    productLandingPageState,
    productLandingPageSend,
  } = useSMProductLandingPage({});

  const _renderPage = () => {
    if (productLandingPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          <LandingPageWidget
            {...(productLandingPageState?.event?.data?.value || {})}
            secondaryColor={theme?.colors?.secondary}
            buttonItem={buttonItem}
            searchBar={true}
          />
        </>
      );
    }
    if (productLandingPageState?.matches('GET_PAGE_CONTENT')) {
      return <div>Loading...</div>;
    }
    return null;
  };
  return <>{_renderPage()}</>;
};
